import { DependencyList, Dispatch, EffectCallback, SetStateAction, useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_TIME = 300;

function dispatchEvent(
  delayedCall: NodeJS.Timeout | undefined,
  setDelayedCall: Dispatch<SetStateAction<NodeJS.Timeout | undefined>>,
  effect: EffectCallback | (() => Promise<unknown>),
  timeout: number,
) {
  if (delayedCall) {
    clearTimeout(delayedCall);
  }

  setDelayedCall(
    setTimeout(() => {
      effect();
    }, timeout),
  );

  return () => {
    if (delayedCall) {
      clearTimeout(delayedCall);
    }
  };
}

export const useDebouncedEffect = (
  effect: EffectCallback | (() => Promise<unknown>),
  deps?: DependencyList,
  timeout: number = DEFAULT_DEBOUNCE_TIME,
) => {
  const [delayedCall, setDelayedCall] = useState<NodeJS.Timeout>();

  return useEffect(() => {
    dispatchEvent(delayedCall, setDelayedCall, effect, timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps ?? []), timeout]);
};
